import { all } from "redux-saga/effects";
import { watchLoginSaga, watchVerifySaga } from "./sagas/userAuthSagas";
import {
  watchEditProfileData,
  watchGetProfileData,
} from "./sagas/userProfileSagas";

import {
  watchAddPalleteSaga,
  watchDeletePalleteSaga,
  watchEditPalleteSaga,
  watchGetPalletesSaga,
  watchGetMaterialsSaga,
} from "./sagas/palleteSagas";

import {
  watchAddProductSaga,
  watchGetCategoriesSaga,
  watchGetSubCategoriesListSaga,
  watchGetSecondSubCategorySaga,
  watchGetBrandsSaga,
  watchGetCategoryFeaturesSaga,
} from "./sagas/createProductSaga";

export default function* rootSaga() {
  yield all([
    watchLoginSaga(),
    watchVerifySaga(),
    //
    watchGetProfileData(),
    watchEditProfileData(),
    //
    watchAddPalleteSaga(),
    watchDeletePalleteSaga(),
    watchEditPalleteSaga(),
    watchGetPalletesSaga(),
    watchGetMaterialsSaga(),
    //
    watchAddProductSaga(),
    watchGetCategoriesSaga(),
    watchGetSubCategoriesListSaga(),
    watchGetSecondSubCategorySaga(),
    watchGetBrandsSaga(),
    watchGetCategoryFeaturesSaga(),
  ]);
}
